import React, { Component } from "react";

export default class Pie extends Component {
  render() {
    return (
      <div className="pie p-1">
        H.XLI Ayuntamiento de Tepic | Sistema de Entrega Recepción 2021
        administracionpublica.mx &copy;
      </div>
    );
  }
}
